import { Routes } from '@angular/router';
import { HasRoleGuard } from '@elderbyte/ngx-auth';
import { PrinterClassComponent } from './printer-class/printer-class.component';
import { PrinterComponent } from './printer/printer.component';
import { AccessDeniedComponent } from './common/access-denied/access-denied.component';

export const routes: Routes = [
  { path: '', redirectTo: '/app/classes', pathMatch: 'full' },
  {
    path: 'app',
    children: [
      {
        path: '',
        redirectTo: 'classes',
        pathMatch: 'full',
      },
      {
        path: 'printers',
        canActivate: [HasRoleGuard],
        component: PrinterComponent,
        data: {
          roles: ['USER']
        }
      },
      {
        path: 'classes',
        canActivate: [HasRoleGuard],
        component: PrinterClassComponent,
        data: {
          roles: ['USER']
        }
      },
      {
        path: 'accessdenied',
        pathMatch: 'full',
        component: AccessDeniedComponent
      }
    ]
  }
];
